import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Divider,
  Paper,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import VMEDHeader from "./VMEDHeader";
import VMEDBasicInfo from "./VMEDBasicInfo";
import VMEDEventTabs from "./VMEDEventTabs";
import axios from "axios";
import { API_GET_ENQUIRY_DETAILS, API_GET_INVOICE } from "../../Util/URLConstants";
import { toast } from "react-toastify";
import VMEDOptions from "./VMEDOptions";
import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";
import TitleWithBack from "../Home/TitleWithBack";
import { align_center, align_column } from "../../Styles/VMStyles";
import { isEmpty } from "../../Util/UtilHelper";
import Loader from "../../Components/Loader";
import VMEDMENUOPTIONS from "./MenuOptions/VMEDMENUOPTIONS";
import MUITypography from "../../Components/MUITypography";
import { ROUTE_ALL_ENQUIRIES, SESSION_USER_ID_KEY } from "../../Util/VMConstants";
import StorageFactory from "../../Util/StorageFactory";
import {
  applyCatalogServicesToEvents,
  getServicesList,
  groupServicesBySubVenue,
} from "../../Services/additionalServicesService";

function VMEnquiryDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isConfirmedStatusArrive,setIsConfirmedStatusArrive] = useState(false);
  const [hasInvoice, setHasInvoice] = useState(false);
  const sessionFactory = new StorageFactory("session");
  const userID = sessionFactory.get(SESSION_USER_ID_KEY);

  const [state, setState] = useState({
    customer: {},
    active_tab: 0,
    events: [],
    user_info: {},
    enquiry_id: '',
    loading:'',
    navigate_from:''
  });

useEffect(() => {
  window.scrollTo(0, 0);
}, []);

useEffect(() => {
  const searchParams = new URLSearchParams(location?.search || "");
  const enquiry_id =
    location?.state?.enquiry_id ||
    searchParams.get("enquiry_id") ||
    sessionStorage.getItem("enquiry_id") ||
    "";
  const navigate_from =
    location?.state?.navigate_from ||
    sessionStorage.getItem("navigate_from") ||
    "";

  if (enquiry_id) {
    setState((prev) => ({
      ...prev,
      enquiry_id,
      navigate_from,
    }));

    // persist in sessionStorage so it's available after navigating back
    sessionStorage.setItem("enquiry_id", enquiry_id);
    sessionStorage.setItem("navigate_from", navigate_from);
  }
}, [location?.state, location?.search]);


  const fetchEnquiryDetails = useCallback(async () => {
    try {
      setState((prev) => ({ ...prev, loading: true }));
      const [enquiryResponse, invoiceResponse, catalogResult] = await Promise.all([
        axios.get(API_GET_ENQUIRY_DETAILS, {
          params: { enquiry_id: state.enquiry_id },
        }),
        axios
          .get(API_GET_INVOICE, { params: { enquiry_id: state.enquiry_id } })
          .catch(() => null),
        userID
          ? getServicesList({ user_id: userID }).catch(() => ({
              success: false,
              data: [],
            }))
          : Promise.resolve({ success: false, data: [] }),
      ]);

      const resp = enquiryResponse.data;
      const invoiceDetails = invoiceResponse?.data?.invoice_info || [];
      setHasInvoice(Array.isArray(invoiceDetails) && invoiceDetails.length > 0);
      setState((prev) => ({ ...prev, loading: false }));
      if (resp.status_code === 200) {
        const details = resp?.enquiry_info;
        const ev_details = resp?.event_info;
        const groupedCatalog = groupServicesBySubVenue(catalogResult?.data || []);
        const eventsWithServices = applyCatalogServicesToEvents(
          ev_details || [],
          groupedCatalog
        );

        setState(prev => ({
          ...prev,
          customer: details,
          events: eventsWithServices,
          user_info: resp?.user_info,
        }));
      } else {
        toast.error(resp.message || 'Failed to fetch enquiry details');
      }
    } catch (error) {  
      setState((prev) => ({ ...prev, loading: false }));
      console.error(error);
      toast.error('Error fetching enquiry details');
    }
  }, [state.enquiry_id, userID]);

  useEffect(() => {
    if (!isEmpty(state.enquiry_id)) {
      fetchEnquiryDetails();
    }
  }, [state.enquiry_id, fetchEnquiryDetails]);

  const refreshEnquiryDetails = () => {
    fetchEnquiryDetails();
  };
  const confirmedStatusUpdated = () => {
    setIsConfirmedStatusArrive(true);

  }

  return (
    <Paper sx={{ padding: 0.3 , ml: { md: 5 }}}>
      <Box>
        {!isEmpty(state.customer) && state.loading === false ? (
          <Box sx={{ border: "1px solid gray", borderRadius: "10px", padding: 2 }}>
            <VMEDHeader
              customer={state.customer}
              events={state.events}
              refreshEnquiryDetails={refreshEnquiryDetails}
              confirmedStatusUpdated={confirmedStatusUpdated}
            />
            <Divider sx={{ margin: 1 }} />
            <VMEDBasicInfo customer={state.customer} />

            <VMEDOptions
              customer={state.customer}
              events={state.events}
              user_info={state.user_info}
              isConfirmedStatusArrive ={isConfirmedStatusArrive}
              hasInvoice={hasInvoice}
            />
            <VMEDMENUOPTIONS   
              enquiry_id= {state.enquiry_id}
              customer={state.customer}
              events={state.events}
              user_info={state.user_info}
              navigate_from={state.navigate_from}
              refreshEnquiryDetails={refreshEnquiryDetails}
              />
         
            <VMEDEventTabs events={state.events} 
                          customer={state.customer}
                          hasInvoice={hasInvoice}
            />
          </Box>
        ) : (
          <Box p={2}>
            <TitleWithBack
              title="Enquiry Details"
              onBackClick={() => navigate('/' + ROUTE_ALL_ENQUIRIES, { replace: true }) }
            />
            <Box sx={{ ...align_column, ...align_center, marginTop: 10, marginBottom: 5 }}>
              <SentimentDissatisfiedIcon style={{ fontSize: 60, color: "#ccc" }} />
              <MUITypography variant="h4" mt={2}>No Enquiry Found</MUITypography>
            </Box>
          </Box>
        )}
      </Box>
     <Loader loading={state.loading} />
    </Paper>
  );
}

export default VMEnquiryDetails;
